module.exports = __webpack_public_path__ + "img/bulb-education-idea.22c904e1.svg";